import React from 'react';
import { TypographyStyled } from './Typography.styles';
const Typography = ({ variant = 'body2', children, color, weight, align, ...props }) => {
    return (React.createElement(TypographyStyled, { variant: variant, color: color, weight: weight, align: align, ...props }, children));
};
export default Typography;
//# sourceMappingURL=Typography.js.map